import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';

const Activite = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-8">
      <div className="container mx-auto px-4">
        <SectionTitle 
          overline={t('mining.activity.title')} 
          highlight="" 
          separatorColor="socabeg-blue" 
          showLogo={true} 
        />
        
        <div className="flex flex-col md:flex-row gap-8">
          {/* Première colonne - Image (20%) */}
          <div 
            className="w-full md:w-[20%] rounded-md shadow-lg bg-center bg-cover"
            style={{ backgroundImage: 'url(images/mine2.jpg)' }}
          >
            <div className="h-full min-h-[300px] md:min-h-[500px]"></div>
          </div>

          {/* Deuxième colonne - Contenu (47%) */}
          <div className="w-full md:w-[47%] space-y-12">
            {/* Bloc 1 - Titre et objectif */}
            <div>
              <h3 className="text-2xl font-extrabold mb-4">
                {t('mining.activity.subtitle')}
              </h3>
              <div className="space-y-4">
                <p className="font-bold">{t('mining.activity.objective')}</p>
                <p className="text-justify">{t('mining.activity.objectiveText')}</p>
              </div>
            </div>

            {/* Bloc 2 - Trois étapes */}
            <div className="space-y-6">
              {[1, 2, 3].map((step) => (
                <div key={step} className="flex items-start space-x-4">
                  <div className="bg-socabeg-blue text-white w-12 h-12 flex items-center justify-center text-xl font-bold rounded-md flex-shrink-0">
                    0{step}
                  </div>
                  <div>
                    <h4 className="font-bold text-lg">
                      {t(`mining.activity.steps.${['mining', 'exploration', 'processing'][step-1]}.title`)}
                    </h4>
                    <p className="text-justify">
                      {t(`mining.activity.steps.${['mining', 'exploration', 'processing'][step-1]}.text`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Troisième colonne - Atout géographique (33%) */}
          <div className="w-full md:w-[33%]">
            <div className="bg-socabeg-blue text-white p-8 rounded-md shadow-lg h-full">
              <h3 className="text-2xl font-extrabold mb-6">
                {t('mining.activity.geographic.title')}
              </h3>
              <div className="space-y-4">
                <p className="text-justify">{t('mining.activity.geographic.content')}</p>
                <ul className="space-y-3 list-disc pl-5">
                  {[1, 2, 3].map((point) => (
                    <li key={point} className="text-justify">
                      {t(`mining.activity.geographic.point${point}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Activite;
